module.exports = __webpack_public_path__ + "static/media/img3-1.3da9b05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/P/img3-1.png
// module id = 1295
// module chunks = 3